// import React, { useEffect, useState } from "react";
// import "./AgentScreen.css";
// import AgentNavBar from "./AgentNavBar";

// const AgentScreen = () => {


//     const [agents, setAgents] = useState([]);


//     const [agent, setAgent] = useState(null);

//     const [properties, setProperties] = useState({});

//     useEffect(() => {
//         const user = JSON.parse(localStorage.getItem("user"));
//         const userId = user?.id;

//         fetch("https://api.propertygalleria.in/master/api/users/agentss")
//             .then(res => res.json())
//             .then(data => {
//                 if (userId) {
//                     const filtered = data.find(
//                         item => Number(item.user_id) === Number(userId)
//                     );

//                     console.log("filtered agent ", filtered);
//                     setAgent(filtered);
//                 }
//             });
//     }, []);

//     useEffect(() => {
//         const user = JSON.parse(localStorage.getItem("user"));
//         const userId = user?.id;

//         fetch("https://api.propertygalleria.in/master/api/get/owner/properties")
//             .then(res => res.json())
//             .then(data => {
//                 if (userId) {
//                     // const filtered = data.data.find(
//                     //     item => Number(item.handling_agent_id) === Number(userId)
//                     // );

//                     const filtered = data.data.filter(
//                         item => item.handling_agent_id === userId
//                     );
//                     console.log("filtered agent Pro", filtered);
//                     setProperties(filtered);
//                 }
//             });
//     }, []);




//     const PropertyLength = properties.length
//     console.log('this is properties', properties)

//     //   const soldCount = properties.filter(property => property.status === "Sold").length;


//     const soldCount = properties.filter(property => property.status && property.status.trim().toLowerCase() === "sold").length;

//     return (
//         <>

//             <AgentNavBar />


//             <div className="layout" style={{ marginTop: '5%' }}>
//                 {/* Sidebar */}
//                 {/* <aside className="sidebar">
//         <h2>Property CRM</h2>
//         <nav>
//           <a href="#">Dashboard</a>
//           <a href="#">Listings</a>
//           <a href="#">Leads</a>
//           <a href="#">Earnings</a>
//           <a href="#">Profile</a>
//         </nav>
//       </aside> */}

//                 {/* Main Content */}
//                 <div className="main">
//                     {/* Header */}
//                     <header className="topbar">
//                         <div>
//                             <h2>Welcome back, <span style={{ textTransform: 'capitalize' }}>{agent?.full_name}</span> </h2>
//                             {/* <p>{agent?.role}</p> */}
//                         </div>
//                         <div className="avatar">
//                             <span style={{ textTransform: 'capitalize' }}> {agent?.full_name?.charAt(0) || "A"}</span>
//                         </div>
//                     </header>

//                     {/* Stats */}
//                     <div className="stats">
//                         <div className="card">
//                             <h3>{PropertyLength}</h3>
//                             <p>Assigned Plots</p>
//                         </div>

//                         <div className="card">
//                             <h3>{soldCount}</h3>
//                             <p>Plots Sold</p>
//                         </div>

//                         <div className="card">
//                             <h3>1</h3>
//                             <p>New Leads</p>
//                         </div>

//                         <div className="card">
//                             <h3>₹1.0L</h3>
//                             <p>Total Earnings</p>
//                         </div>
//                     </div>

//                     {/* Available Plots */}
//                     <div className="content-section">
//                         <h2>Available Plots</h2>

//                         <div className="plot">
//                             <div>
//                                 <h3>Plot 4</h3>
//                                 <p>1200 sq ft</p>
//                             </div>

//                             <div>
//                                 <strong>₹10,00,000</strong>
//                                 <button>View Details</button>
//                             </div>
//                         </div>
//                     </div>
//                 </div>
//             </div>

//         </>
//     );
// };

// export default AgentScreen;


import React, { useEffect, useState } from "react";
import "./AgentScreen.css";
import AgentNavBar from "./AgentNavBar";
import axios from "axios";


import Modal from "react-modal";
import LeadScreen, { LeadForm } from "./LeadScreen";


Modal.setAppElement("#root");

const API_BASE = "https://api.propertygalleria.in/master/api";

const AgentScreen = () => {
    const [agents, setAgents] = useState([]);
    const [agent, setAgent] = useState(null);
    const [properties, setProperties] = useState([]);

  const [leads, setLeads] = useState([]);


const [isEditOpen, setIsEditOpen] = useState(false);
const [selectedLead, setSelectedLead] = useState(null);
const [projects, setProjects] = useState([]);



useEffect(() => {
  axios.get(`${API_BASE}/get/projects`)
    .then(res => setProjects(res.data));
}, []);
const openEditLead = (lead) => {
  setSelectedLead(lead);
  setIsEditOpen(true);
};


    useEffect(() => {
        const user = JSON.parse(localStorage.getItem("user"));
        const userId = user?.id;

        fetch("https://api.propertygalleria.in/master/api/users/agentss")
            .then(res => res.json())
            .then(data => {
                if (userId) {
                    const filtered = data.find(item => Number(item.user_id) === Number(userId));
                    setAgent(filtered);
                }
            });
    }, []);

    useEffect(() => {
        const user = JSON.parse(localStorage.getItem("user"));
        const userId = user?.id;

        fetch("https://api.propertygalleria.in/master/api/get/owner/properties")
            .then(res => res.json())
            .then(data => {
                if (userId) {
                    const filtered = data.data.filter(item => item.handling_agent_id === userId);
                    setProperties(filtered);
                }
            });
    }, []);

    const PropertyLength = properties.length;
    const soldCount = properties.filter(property => property.status?.trim().toLowerCase() === "sold").length;

    


  const fetchInvestorLead = async () => {
    const user = JSON.parse(localStorage.getItem("user"));
    const userId = Number(user?.id);

    const res = await axios.get(`${API_BASE}/investorLeads`);

    const filtered = res.data.filter(
      item => Number(item.handling_agent_id) === userId
    );

    setLeads(filtered);
  };

    useEffect(() => {
    fetchInvestorLead();
  }, []);
  
// console.log('this is leads',leads)

const leadsCount = leads.length;


const formatDateTime = (dateString) => {
    
  if (!dateString) return ""; // extra safety

  const date = new Date(dateString);

  return date.toLocaleString("en-IN", {
    day: "2-digit",
    month: "2-digit",
    year: "numeric",
    hour: "2-digit",
    minute: "2-digit",
    hour12: true,
  });
};


const isPendingTask = (dateString) => {
      if (!dateString) return false; 

  const leadDate = new Date(dateString);
  const today = new Date();

  // Remove time part for accurate date comparison
  leadDate.setHours(0, 0, 0, 0);
  today.setHours(0, 0, 0, 0);

  return leadDate < today;
};

const isTodayTask = (dateString) => {
  if (!dateString) return false;

  const taskDate = new Date(dateString);
  const today = new Date();

  taskDate.setHours(0, 0, 0, 0);
  today.setHours(0, 0, 0, 0);

  return taskDate.getTime() === today.getTime();
};


    return (
        <>
            <AgentNavBar />

            
  {/* Header */}
                    <header className="topbar" >
                        <div>
                            <h2>Welcome back, <span style={{ textTransform: 'capitalize' }}>{agent?.full_name}</span></h2>
                        </div>
                        <div className="avatar">
                            <span style={{ textTransform: 'capitalize' }}> {agent?.full_name?.charAt(0) || "A"}</span>
                        </div>
                    </header>

                    {/* Stats */}
                    <div className="stats">
                        <div className="card">
                            <h3>{PropertyLength}</h3>
                            <p>Assigned Plots</p>
                        </div>

                        <div className="card">
                            <h3>{soldCount}</h3>
                            <p>Plots Sold</p>
                        </div>

                        <div className="card">
                            <h3>{leadsCount}</h3>
                            <p>Total Leads</p>
                        </div>

                        {/* <div className="card">
                            <h3>₹1.0L</h3>
                            <p>Total Earnings</p>
                        </div> */}
                    </div>
            {/* <div className="layout" >
              
                <div className="main">
                  

                
                    <div className="content-section">
                        <h2>Pending Leads</h2>

                        {leads.map((property, index) => (
                            <div className="plot" key={index}>
                                <div>
                                     <h3>{property.full_name || "Name: N/A"}</h3>
                                    <p>{property.location || `Plot ${index + 1}`}</p>
                              
                                </div>

                                <div>
                                    <strong>{`₹${property.investment_range || "0"}`}</strong>
                                    <button className="view-details-btn">Manage Lead Details</button>
                                </div>
                            </div>
                        ))}
                    </div>
                </div>
            </div>


               <div className="layout1" >
              
                <div className="main">
                  

                    <div className="content-section">
                        <h2>Today Leads</h2>

                        {properties.map((property, index) => (
                            <div className="plot" key={index}>
                                <div>
                                    <h3>{property.plot_name || `Plot ${index + 1}`}</h3>
                                    <p>{property.size || "Size: N/A"}</p>
                                </div>

                                <div>
                                    <strong>{`₹${property.price || "0"}`}</strong>
                                    <button className="view-details-btn">Manage Lead Details</button>
                                </div>
                            </div>
                        ))}
                    </div>
                </div>
            </div> */}



<div className="lead-columns">

  {/* LEFT – Pending Leads status_updated_at */}
  {/* <div className="lead-column">
    <h2>Pending Task</h2>

    {leads.filter(
      (lead) =>
        lead.status_updated_at && // 🚫 skip NULL dates
        isPendingTask(lead.status_updated_at)
    )
    .map((lead, index) => (
      <div className="plot" key={index}>
        <div>
          <h3>{lead.full_name || "N/A"}</h3>
          <p>{lead.location}</p>
            <p>Date: {lead.status_updated_at}</p>
        </div>

        <div>
          <strong>₹{lead.investment_range}</strong>
          <button
            className="view-details-btn"
            onClick={() => openEditLead(lead)}
          >
            Manage Lead Details
          </button>
        </div>
      </div>
    ))}
  </div> */}


  <div className="lead-column">
  <h2>Pending Task</h2>

  {(() => {
    const pendingLeads = leads.filter(
      (lead) =>
        lead.status_updated_at &&
        isPendingTask(lead.status_updated_at)
    );

    if (pendingLeads.length === 0) {
      return (
        <div className="no-pending">
          <span style={{ fontSize: "40px" }}>🎉</span>
          <p>No Pending Tasks</p>
        </div>
      );
    }

    return pendingLeads.map((lead, index) => (
      <div className="plot" key={index}>
        <div>
          <h3>{lead.full_name || "N/A"}</h3>
          <p>{lead.location}</p>
          <p>Date: {formatDateTime(lead.status_updated_at)}</p>
        </div>

        <div>
          <strong>₹{lead.investment_range || "No Investmenet Range"}</strong>
          <button
            className="view-details-btn"
            onClick={() => openEditLead(lead)}
          >
            Manage Lead Details
          </button>
        </div>
      </div>
    ));
  })()}
</div>


  {/* RIGHT – Today Leads */}
  {/* <div className="lead-column">
    <h2>Today Task</h2>

    {properties.map((property, index) => (
      <div className="plot" key={index}>
        <div>
          <h3>{property.plot_name}</h3>
          <p>{property.size}</p>
        
        </div>

        <div>
      
          <strong>₹{property.investment_range}</strong>
          <button className="view-details-btn">
            Manage Lead Details
          </button>
        </div>
      </div>
    ))}
  </div> */}
<div className="lead-column">
  <h2>Today Task</h2>

  {(() => {
    const todayTasks = leads.filter(
      (property) =>
        property.status_updated_at &&
        isTodayTask(property.status_updated_at)
    );

    if (todayTasks.length === 0) {
      return (
        <div className="no-pending">
          <span style={{ fontSize: "40px" }}>📅</span>
          <p>No Today Tasks</p>
        </div>
      );
    }

    return todayTasks.map((lead, index) => (
      <div className="plot" key={index}>
        <div>
          <h3>{lead.full_name}</h3>
          <p>{lead.location}</p>
          <p>
            Date: {formatDateTime(lead.status_updated_at)}
          </p>
        </div>

        <div>
          <strong>₹{lead.investment_range|| "No Investmenet Range"}</strong>
          <button  onClick={() => openEditLead(lead)} className="view-details-btn">
            Manage Lead Details
          </button>
        </div>
      </div>
    ));
  })()}
</div>

</div>
<Modal
  isOpen={isEditOpen}
  onRequestClose={() => setIsEditOpen(false)}
  className="modal"
  overlayClassName="overlay"
>
  <LeadForm
    title="Manage Lead"
    lead={selectedLead}
    projects={projects}
    onClose={() => setIsEditOpen(false)}
    onSaved={() => {
      setIsEditOpen(false);
      fetchInvestorLead();
    }}
  />
</Modal>



        </>
    );
};

export default AgentScreen;
